import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from '../firebase/config';

export const uploadProfileImage = async (userId, file) => {
  try {
    // 파일 경로 설정: users/{userId}/profile/{filename}
    const filename = `${Date.now()}_${file.name}`;
    const storageRef = ref(storage, `users/${userId}/profile/${filename}`);
    
    // 파일 업로드
    await uploadBytes(storageRef, file);
    
    // 업로드된 파일의 다운로드 URL 반환
    const downloadURL = await getDownloadURL(storageRef);
    return downloadURL;
  } catch (error) {
    console.error('프로필 이미지 업로드 실패:', error);
    throw error;
  }
}; 